import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=3f4fee43&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\cgproject\\canggu-official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4fee43"]])

export default __exports__